<template>
	<!-- 数据卡片 -->
	<div class="ledger-cards">
		<el-card class="ledger-cards-item" shadow="hover" v-for="(item, index) in data" :key="index">
			<div class="ledger-cards-body">
				<div class="ledger-cards-content">
					<div class="header">
						<div>
							{{ item.label }}
						</div>
						<div class="tip" v-if="item.info">
							<el-tooltip effect="dark" :content="item.content" placement="top">
								<i class="fa fa-question-circle-o" style="color: #999; font-size: 14px"></i>
							</el-tooltip>
						</div>
					</div>
					<div class="ledger-cards-content-value" :style="{ color: item.color }">
						<span>{{ item.value }}&nbsp;</span>
						<span>{{ item.unit }}</span>
					</div>
				</div>
				<div v-if="item.slot" class="slot">
					<div>{{ item.slot.label }}</div>
					<div class="slot-value" :style="{ color: item.slot.color }">
						<span>{{ item.slot.value }}</span>
						<span>{{ item.slot.unit }}</span>
					</div>
				</div>
			</div>
		</el-card>
	</div>
</template>

<script>
	export default {
		name: 'ResourceManage',
		components: {},
		props: {
			data: {
				type: Array,
				default: () => [],
			},
		},
	};
</script>

<style lang="scss" scoped>
	.ledger-cards {
		text-align: left;
		margin: 0 0 10px 0;
		display: flex;
		justify-content: space-around;
		gap: 10px;
		&-body {
			flex: 1;
			display: flex;
			justify-content: space-between;
			align-items: center;
		}
		&-item {
			width: 100%;
		}
		&-content {
			display: flex;
			flex-direction: column;
			gap: 10px;
			color: #666;
			&-value {
				font-size: 20px;
				font-weight: bold;
			}
			.header {
				display: flex;
				gap: 5px;
				align-items: center;
			}
		}

		.slot {
			display: flex;
			flex-direction: column;
			align-items: flex-end;
			gap: 5px;
			font-size: 12px;
			&-value {
				font-size: 14px;
				font-weight: 600;
			}
		}
	}

	.tip {
		cursor: help;
	}
</style>
